<template>
  <div>

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">
        {{ snackbar_msg }}
      </span>

      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>

    <!-- Filter -->
    <v-card class="box no-display" v-if="ay_std_div_list != null">

      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Activity Summary Report</strong>
        </v-toolbar-title>
      </v-toolbar>

      <v-row justify="center" dense>

        <!-- Academic Year -->
        <v-col sm="2">
          <v-icon color="error">*</v-icon>

          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined />
        </v-col>

        <!-- From Date -->
        <v-col sm="2">
          <v-menu v-model="fromDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="from_date" label="From Date" prepend-icon="mdi-calendar" readonly outlined dense
                v-bind="attrs" v-on="on" />
            </template>

            <v-date-picker v-model="from_date" @input="fromDateMenu = false" />
          </v-menu>
        </v-col>

        <!-- To Date -->
        <v-col sm="2">
          <v-menu v-model="toDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="to_date" label="To Date" prepend-icon="mdi-calendar" readonly outlined dense
                v-bind="attrs" v-on="on" />
            </template>


            <v-date-picker v-model="to_date" :min="from_date" @input="toDateMenu = false" />
          </v-menu>
        </v-col>

        <!-- Fetch -->
        <v-col sm="2">
          <v-btn class="mt-2 button" @click="getReport()" :loading="fetch_loader">
            Fetch
          </v-btn>
        </v-col>

      </v-row>

    </v-card>

    <!-- Report Table -->
    <v-card class="box" v-if="summary_report && summary_report.length > 0">

      <v-col cols="12" sm="12" md="12">

        <v-btn class="ma-2 no-display" rounded color="success" outlined
          @click="fnExcelReport('my-table-id', 'ActivitySummaryReport')">
          <v-icon color="success">
            mdi-export
          </v-icon>

          Export
        </v-btn>

      </v-col>

      <div id="my-table-id">

        <v-data-table :headers="headers1" :items="summary_report" :search="search" dense class="elevation-1 mytable">
        </v-data-table>

      </div>

    </v-card>

  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {

      fetch_loader: false,
      from_date: null,
      to_date: null,
      snackbar: false,
      snackbar_msg: "",
      color: "",
      fromDateMenu: false,
      toDateMenu: false,
      search: "",

      ay_std_div_list: null,
      sel_ay_data: null,

      summary_report: [],

      headers1: [
        {
          text: "Sr. No.",
          value: "sr_no",
        },
        {
          text: "Activity",
          value: "activity_name",
        },
        {
          text: "Category",
          value: "category",
        },
        {
          text: "Participant",
          value: "totalParticipant",
        },
        {
          text: "Attendance %",
          value: "attendance_percentage",
        },
        {
          text: "Feedback Avg",
          value: "feedback_average",
        },
        {
          text: "Collection in Rs",
          value: "collection",
        },
        {
          text: " Academic Year",
          value: "academicYear",
        },
        {
          text: "Duration",
          value: "start-end-date",
        },
      ],
    };
  },
  methods: {

    fnExcelReport(id, name) {

  let tab_text = `
    <table border="1">
      <tr>
        <th>SR. No.</th>
        <th>Activity</th>
        <th>Category</th>
        <th>Participant</th>
        <th>Attendance %</th>
        <th>Feedback Avg</th>
        <th>Collection in Rs</th>
        <th>Academic Year</th>
        <th>Duration</th>
      </tr>
  `;

  this.summary_report.forEach((item, index) => {

    tab_text += `
      <tr>
        <td>${index + 1}</td>
        <td>${item.activity_name || "-"}</td>
        <td>${item.category || "-"}</td>
        <td>${item.totalParticipant != null ? item.totalParticipant : 0}</td>
        <td>${item.attendance_percentage != null ? item.attendance_percentage + "%" : "0%"}</td>
        <td>${item.feedback_average != null ? item.feedback_average : 0}</td>
        <td>${item.collection != null ? item.collection : 0}</td>
        <td>${item.academicYear || "-"}</td>
        <td>${item["start-end-date"] || "-"}</td>
      </tr>
    `;

  });

  tab_text += `
    </table>
  `;

  const blob = new Blob(
    [tab_text],
    {
      type: "application/vnd.ms-excel"
    }
  );

  const filename =
    name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

  if (
    window.navigator &&
    window.navigator.msSaveOrOpenBlob
  ) {

    window.navigator.msSaveOrOpenBlob(
      blob,
      filename
    );

  } else {

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");

    a.href = url;
    a.download = filename;

    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);

    window.URL.revokeObjectURL(url);
  }
},


    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    getReport() {
      this.summary_report = [];
      this.fetch_loader = true;

      // Convert yyyy-MM-dd to dd-MM-yyyy
      const formatDate = (date) => {
        if (!date) return null;

        const parts = date.split("-");

        if (parts.length === 3) {
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }

        return date;
      };

      const data = {
        ay: this.sel_ay_data ? this.sel_ay_data.id : null,
        from_date: formatDate(this.from_date),
        to_date: formatDate(this.to_date),
      };

      console.log("Activity Summary Request:", data);

      axios
        .post("/Activity/getActivitySummaryReport", data)
        .then((res) => {
          console.log("Activity Summary Response:", res.data);

          if (res.data.summary_report) {
            this.summary_report = res.data.summary_report.map(
              (item, index) => {
                return {
                  ...item,
                  sr_no: index + 1,
                };
              }
            );
          } else {
            this.summary_report = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.showSnackbar(
            "#b71c1c",
            "Something went wrong..."
          );
        })
        .finally(() => {
          this.fetch_loader = false;
        });
    },


    onload() {

      axios
        .post("/Activity/getInitaialData")
        .then((res) => {
          this.ay_std_div_list = res.data.ay_list || [];

        })
        .catch((error) => {

          console.log(error);

          this.showSnackbar(
            "#b71c1c",
            "Something went wrong..."
          );

        });

    },
  },
  mounted() {
    this.onload();
  },
};
</script>

<style scoped>
.mytable2 /deep/ thead th {
  background: #0f2027 !important;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027) !important;
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027) !important;
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
